import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import ImageGallery from "~/Components/Gallery/ImageGallery.vue";

new VueApp( {
  name: "Gallery",
  components: {
    ImageGallery
  }
} );
